module.exports = __webpack_public_path__ + "static/img/share04.4ab139d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share04.png
// module id = 7891
// module chunks = 1